module.exports = __webpack_public_path__ + "static/media/maintenance-669df40d510f01658c030fa5c8b70bd1.gif";